import { createFileRoute } from "@tanstack/react-router";

import { Breadcrumbs, ScreenContent, ScreenHeader } from "@/ui";
import { formatEmailType } from "@/utils/email-analytics";
import { DeliveryIssuesCard } from "./-components/delivery-issues-card";
import { TrendCard } from "./-components/trend-card";
import { TypeSummaryCard } from "./-components/type-summary-card";

const EmailTypeDetailPage = () => {
  const { "email-type": emailType } = Route.useParams();

  return (
    <>
      <ScreenHeader>
        <Breadcrumbs
          items={[
            { label: "Notification analytics", to: "/notification-analytics" },
            {
              label: formatEmailType(emailType),
              to: "/notification-analytics/$email-type",
              params: { "email-type": emailType },
            },
          ]}
        />
      </ScreenHeader>

      <ScreenContent>
        <div className="flex flex-col gap-6">
          <div className="flex min-w-0 flex-col gap-1">
            <h2 className="text-2xl font-bold break-words text-content-strong">
              {formatEmailType(emailType)}
            </h2>

            <p className="font-mono text-xs break-all text-content-muted">{emailType}</p>
          </div>

          <TypeSummaryCard emailType={emailType} />

          <TrendCard emailType={emailType} showIntervalToggle />

          <DeliveryIssuesCard emailType={emailType} />
        </div>
      </ScreenContent>
    </>
  );
};

export const Route = createFileRoute("/_private/notification-analytics/$email-type/")({
  component: EmailTypeDetailPage,
});
